import cn from "clsx";

import type { FeedItem } from "../../../../types/content/feedItem";

import { TeaserCluster } from "../../../TeaserCluster/TeaserCluster";
import { FeedItemToTeaser } from "../../utils/feedItemToTeaser";
import styles from "./LatestNewsArticleCluster.module.scss";

const LatestNewsArticleCluster = ({
  feedItem,
  isLastElement,
  isFirstElement,
  shouldPrioritizeImageLoad,
  positionInFeed,
  teaserWeight,
  isLoggedIn,
}: {
  feedItem: FeedItem;
  isLastElement?: boolean;
  isFirstElement?: boolean;
  shouldPrioritizeImageLoad?: boolean;
  positionInFeed: number;
  teaserWeight: number | null;
  isLoggedIn?: boolean;
}) => {
  return (
    <div
      className={cn([
        styles.latestNewsArticleContainer,
        isFirstElement && styles.firstArticle,
        isLastElement && styles.lastArticle,
      ])}
    >
      <TeaserCluster
        footer={null}
        header={feedItem.header}
        style={feedItem.style}
        hasCardStyling={false}
        isSmallCluster
        teaserWeightValue={teaserWeight}
        isLoggedIn={isLoggedIn}
      >
        <FeedItemToTeaser
          feedItem={feedItem}
          positionInFeed={positionInFeed}
          shouldPrioritizeImages={shouldPrioritizeImageLoad}
        />
      </TeaserCluster>
      {!isLastElement && <hr className={styles.separator} />}
    </div>
  );
};

export { LatestNewsArticleCluster };
